import * as yup from "yup";

export const contactValidationSchema = yup.object().shape({
  fullName: yup.string().required("full name is a required field"),
  email: yup.string().email("please enter a valid email").required("email is a required field"),
  organization: yup.string().required("organization is a required field"),
  message: yup.string().required("message is a required field"),
});
